// Types
import { LeadsRaw, LeadsForViewType, paginationState, leadsRawState } from '../../types/LeadsList';

export default function ACL_importAllLeads(data: LeadsRaw | undefined): LeadsForViewType {
    let _transformed: LeadsForViewType = {
        list: [],
        page: paginationState,
    };

    if (data) {
        const { _embedded, page } = data;

        _transformed = {
            list: _embedded ? _embedded.leadViewList : leadsRawState._embedded.leadViewList,
            page: page ? page : paginationState,
        };

        _transformed.list = _transformed.list.map((item: { [key: string]: string }) => ({
            ...item,
            customerFullName: `${item.customerFirstName} ${item.customerLastName}`,
        }));
    }

    return _transformed;
}
